module.exports = __webpack_public_path__ + "img/undraw4.84c3e2e8.jpg";